import moment from 'moment';
let searchDate = moment().startOf().format('YYYYMM');
export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), 
	groups: GROUPS(),
	partTypeList: [
			{
				"commCd": "MEA",
				"commCdName": "MEA",
				"commCdType": "PART_G"
			},
			{
				"commCd": "EGA",
				"commCdName": "EGA",
				"commCdType": "PART_G"
			}
		], 
	mdjTbList: [], 
	dayCols: [], 
	ngType: [],
	ngItem: {},
	pieChartLabel: [],
	pieChartData: [], 
	barChartLabel: [],
	barChartData: [], 
	ngCdList: [],
	ngCauseList: [],
	isLoading: false,
	maxbarVal: 100
};

function GROUPS() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SEARCH_PARAMS() {
	return {
		partType: 'MEA', 
		prePartType: "MEA",
		searchDate: searchDate 
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO, GROUPS };
